import React from 'react';

import './styles.css';

const Divider = () => {
  return (
    <div className="divider">
      <span></span>
      <span>&#10038;</span>
      <span></span>
    </div>
  );
};

export default Divider;
